import React from "react";
import { getImageUrl } from "../others/Functions";

const Output = ({ _id, pic, picPosition, cropAreaAspect }) => {
  let pic1 =
    pic !== ""
      ? `${getImageUrl().replace('"', "")}${_id}/${pic}`
      : `${getImageUrl()}sys/defaultInvPic.jpeg`;
  const scale = 100 / picPosition.width;
  const transform = {
    x: `${-picPosition.x * scale}%`,
    y: `${-picPosition.y * scale}%`,
    scale,
    width: "calc(100% + 0.5px)",
    height: "auto",
  };

  const imageStyle = {
    transform: `translate3d(${transform.x}, ${transform.y}, 0) scale3d(${transform.scale},${transform.scale},1)`,
    width: transform.width,
    height: transform.height,
    position: "absolute",
    top: 0,
    left: 0,
    transformOrigin: "top left",
  };

  return (
    <div
      style={{
        paddingBottom: `${100 / (cropAreaAspect.x / cropAreaAspect.y)}%`,
        position: "relative",
        maxWidth: "100%",
        overflow: "hidden",
        boxShadow: "0 0 5px rgba(0, 0, 0, 0.3)",
      }}
    >
      <img src={pic1} alt="pic1" style={imageStyle} />
    </div>
  );
};

export default Output;
